import { SaleDetailModel } from 'api-hooks/sale/model';
import * as React from 'react';

import HotelRescheduleForm from './form';

interface Props {
  hotelSale: SaleDetailModel;
}

export default function HotelReschedule(props: Props) {
  const { hotelSale } = props;
  return <HotelRescheduleForm {...props} hotelSale={hotelSale} />;
}
